import { PhraseMap } from '@ms/yammer-i18n';

import { useTranslationsOptions } from './useTranslationsContext';

export interface StringWrapperCtor<T> {
  readonly feature: string;
  new (locale: string, phrases: PhraseMap): T;
}

export type UseTranslations = <T>(Strings: StringWrapperCtor<T>) => T;
export const useTranslations: UseTranslations = <T>(from: StringWrapperCtor<T>): T => {
  const { useLoader } = useTranslationsOptions();

  return useLoader(from);
};
